import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import Loading from "../components/Loading";
import { APP_HOME_PATH } from "../config/routes";
import LandingPage from "../pages/LandingPage";

export default function PublicRoot() {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) return <Loading />;
  if (isAuthenticated) return <Navigate to={APP_HOME_PATH} replace />;
  return <LandingPage />;
}
